import { z } from 'zod'
import {
  ETCS_EINFAHRWEICHE_MAX_LENGTH,
  ETCS_EINFAHRWEICHE_REGEXP,
  FREITEXT_LONG_MAX_LENGTH,
  FREITEXT_LONG_REGEXP,
  KM_SIGNAL_MAX_LENGTH,
  KM_SIGNAL_REGEXP,
  KMH_MAX_LENGTH,
  KMH_REGEXP,
  ZUGMELDESTELLE_MAX_LENGTH,
  ZUGMELDESTELLE_REGEXP
} from '../../../../utils'
import { Betriebsstellenart } from '../../../../types'
import { allowedChars } from '../../../../utils/customValidationMessage'

export const KmSchema = z
  .string()
  .max(KM_SIGNAL_MAX_LENGTH)
  .superRefine(allowedChars(KM_SIGNAL_REGEXP))
  .default('')

export const SignalSchema = z
  .string()
  .max(KM_SIGNAL_MAX_LENGTH)
  .superRefine(allowedChars(KM_SIGNAL_REGEXP))
  .default('')

export const ZugmeldestelleNameSchema = z
  .string()
  .max(ZUGMELDESTELLE_MAX_LENGTH)
  .superRefine(allowedChars(ZUGMELDESTELLE_REGEXP))
  .default('')

const DEFAULT_ZUGMELDESTELLE = {
  art: '' as const,
  name: ''
}

export const ZugmeldestelleSchema = z
  .object({
    art: z
      .enum(Betriebsstellenart, { error: 'Bitte auswählen.' })
      .or(z.literal(''))
      .transform((e) => (e === '' ? '' : (e as Betriebsstellenart)))
      .default(DEFAULT_ZUGMELDESTELLE.art),
    name: ZugmeldestelleNameSchema.default(DEFAULT_ZUGMELDESTELLE.name)
  })
  .default(() => structuredClone(DEFAULT_ZUGMELDESTELLE))

export const FreitextSchema = z
  .string()
  .max(FREITEXT_LONG_MAX_LENGTH)
  .superRefine(allowedChars(FREITEXT_LONG_REGEXP))
  .default('')

export const KmhSchema = z
  .string()
  .max(KMH_MAX_LENGTH)
  .superRefine(allowedChars(KMH_REGEXP))
  .default('')

// Add schemas for Befehl 28
export const EtcsLevelSchema = z
  .string()
  .max(ETCS_EINFAHRWEICHE_MAX_LENGTH)
  .superRefine(allowedChars(ETCS_EINFAHRWEICHE_REGEXP))
  .default('')

export const EtcsBetriebsartSchema = z
  .union([
    z.literal(''),
    z
      .string()
      .max(ETCS_EINFAHRWEICHE_MAX_LENGTH)
      .superRefine(allowedChars(ETCS_EINFAHRWEICHE_REGEXP))
  ])
  .default('')
